import React, { useState } from 'react'
import { AlertBanner } from './components/AlertBanner'
import PrivacyForm from './components/PrivacyForm'

export default function App() {
  const [formIsSubmitted, setFormIsSubmitted] = useState(false)
  const [emailSuccessStatus, setEmailSuccessStatus] = useState(null)
  const privacyEmailEndpointUrl = document
    .getElementById('privacyEmailEndpoint')
    ?.getAttribute('data-url')
  const bannerStyle = { minWidth: '250px', maxWidth: '650px' }

  function submitForm(privacyRequest) {
    setFormIsSubmitted(true)

    // Scroll to top
    window.scrollTo(0, 0)

    // Make the request
    fetch(privacyEmailEndpointUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(privacyRequest)
    })
      .then((res) => res.json())
      .then((res) => {
        let response = JSON.parse(res)

        if (response.emailSent === '1') {
          setEmailSuccessStatus(true)
        } else {
          setEmailSuccessStatus(false)
        }
      })
      .catch((err) => {
        console.error('Privacy form submission error:', err)
        setEmailSuccessStatus(false)
      })
  }

  if (!formIsSubmitted) {
    return (
      <>
        <PrivacyForm submit={submitForm} />
      </>
    )
  } else if (!privacyEmailEndpointUrl) {
    return (
      <AlertBanner
        type='danger'
        heading='There is a configuration issue. We are sorry for the inconvenience.'
        body='Please call us at 800.366.6654.'
        style={bannerStyle}
      />
    )
  } else if (emailSuccessStatus === null) {
    return <div style={bannerStyle}>Loading...</div>
  } else if (emailSuccessStatus === true) {
    return (
      <AlertBanner
        type='primary'
        heading='Thanks. We’ve received your request.'
        body='If you have any questions, please call us at 800.366.6654.'
        style={bannerStyle}
      />
    )
  } else if (emailSuccessStatus === false) {
    return (
      <AlertBanner
        type='danger'
        heading='The email was not sent successfully. We are sorry for the inconvenience.'
        body='Please call us at 800.366.6654.'
        style={bannerStyle}
      />
    )
  }
}
